import { DataLayerProps } from 'models/data-layer'

const BASE = 'https://www.cashme.com.br/documentos/pdf'

export const CODE_OF_CONDUCT_URL = `${BASE}/260817/Codigo_de_Conduta_Etica_2026.pdf`
export const SUPPLIER_CODE_URL = `${BASE}/260817/Codigo_de_Relacionamento_com_Fornecedores_2026.pdf`
export const PRIVACY_NOTICE_URL = `${BASE}/250725/Aviso_de_Privacidade_CashMe.pdf`
export const WHISTLEBLOWING_URL = 'https://contatoseguro.com.br/cashme/'
export const CYRELA_FINANCIALS_URL =
  'https://ri.cyrela.com.br/informacoes-financeiras/central-de-resultados/'
export const COMPLIANCE_EMAIL = 'compliance@cashme.com.br'

export type IntegrityDocument = {
  id: string
  title: string
  href: string
  dataLayer: DataLayerProps
}

const layer = (title: string): DataLayerProps => ({
  category: 'Clique',
  action: 'Programa de Integridade',
  label: `Nossas Diretrizes - ${title}`
})

const doc = (id: string, title: string, href: string): IntegrityDocument => ({
  id,
  title,
  href,
  dataLayer: layer(title)
})

export const documents: IntegrityDocument[] = [
  doc('codigo-conduta', 'Código de Conduta Ética', CODE_OF_CONDUCT_URL),
  doc('codigo-fornecedor', 'Código de Relacionamento com o Fornecedor', SUPPLIER_CODE_URL),
  doc(
    'politica-programa',
    'Política Gestão do Programa de Integridade',
    `${BASE}/240927/Politica_Gestao_do_Programa_de_Integridade_CashMe.pdf`
  ),
  doc(
    'politica-prevencao',
    'Política de Prevenção: Anticorrupção, Antissuborno, Fraude e PLD',
    `${BASE}/240417/Politica_de_Prevencao_Anticorrupcao_Antissuborno_Fraude_e_PLD_CashMe.pdf`
  ),
  doc('politica-riscos', 'Política de Gestão de Riscos', `${BASE}/240417/Politica_de_Gestao_de_Riscos_CashMe.pdf`),
  doc('aviso-privacidade', 'Aviso de Privacidade', PRIVACY_NOTICE_URL),
  doc(
    'transparencia-2s2026',
    'Relatório de Transparência Salarial | 2º Semestre 2026',
    `${BASE}/260925/Relatorio_de_Transparencia_Salarial_-_2o_Semestre_2026.pdf`
  ),
  doc(
    'transparencia-1s2026',
    'Relatório de Transparência e Equidade Salarial | 1º Semestre 2026',
    `${BASE}/260817/Relatorio_de_Transparencia_e_Equidade_Salarial_-_1o_semestre_2026.pdf`
  ),
  doc(
    'boletim-2024',
    'Boletim do Programa de Integridade 2024',
    `${BASE}/250219/CashMe_Boletim_do_Programa_de_Integridade_2024.pdf`
  ),
  doc(
    'boletim-2025',
    'Boletim do Programa de Integridade 2025',
    `${BASE}/260219/CashMe_Boletim_do_Programa_de_Integridade_2025.pdf`
  )
]
